import { render, staticRenderFns } from "./Record.html?vue&type=template&id=2a5850f8&external"
import script from "./Record.ts?vue&type=script&lang=ts&external"
export * from "./Record.ts?vue&type=script&lang=ts&external"
import style0 from "./Record.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports